import React from "react";
import FaqsAccordion from "./FaqsAccordion";

function FaqSection() {
  const accordionItems = [
    {
      title:
        "What makes Vodote Techa different from other cybersecurity companies?",
      content:
        "Vodote Techa stands apart due to its elite team of industry veterans who have safeguarded systems for Fortune 100 enterprises. Our approach is proactive, tailored, and aligned with real-world threats—not textbook solutions.",
    },
    {
      title:
        "Do I need cybersecurity services even if I’m a small or mid-sized business?",
      content:
        "Absolutely. Cybercriminals often target small to mid-sized businesses assuming they lack strong defenses. Vodote Techa provides scalable, cost-effective solutions to protect your digital infrastructure, no matter your company size.",
    },
    {
      title: "How do you assess the vulnerabilities in my system?",
      content:
        "We use a multi-layered vulnerability assessment approach that combines automated tools and manual testing. Our experts simulate real-world attacks to uncover weak points before hackers do.",
    },
    {
      title:
        "Is your security testing safe for my website and applications?",
      content:
        "Yes. All our testing is conducted in a controlled environment with zero impact on your operations. We strictly follow responsible disclosure practices and never compromise your data.",
    },
    {
      title:
        "How often should I conduct penetration testing?",
      content:
        "We recommend testing at least once a year, or after any major code changes, system upgrades, or compliance updates. Regular testing keeps your defenses resilient against evolving threats.",
    },
    {
      title:
        "What industries do you serve?",
      content:
        "Vodote Techa serves a wide range of sectors, including healthcare, finance, e-commerce, education, government, and critical infrastructure. Our flexible solutions adapt to specific regulatory and security needs.",
    },
    {
      title:
        "Do you offer support after the audit or testing is completed?",
      content:
        "Yes. We don’t just point out issues, we help you fix them. Our team offers remediation guidance, technical support, and optional re-testing to ensure vulnerabilities are properly resolved.",
    },
    {
      title:
        "Can you help with compliance requirements like ISO, HIPAA, or PCI-DSS?",
      content:
        "Yes, we specialize in helping organizations meet and maintain compliance standards through targeted audits, documentation, and technical control implementation.",
    },
    {
      title:
        "Is your team certified?",
      content:
        "Yes. Our experts hold globally recognized certifications such as CEH, OSCP, CISSP, and CISA. But beyond certifications, they bring years of hands-on experience in high-risk environments.",
    },
    {
      title:
        "How do I get started?",
      content:
        "Simply contact us to schedule a free initial consultation. We’ll discuss your needs, identify the right services for your business, and map out the next steps in strengthening your cybersecurity posture.",
    },
  ];
  return (
    <section className="faqSection">
      <div className="container">
        <div className="sectionTitle">
          <h4>Understanding Our Cyber Security Solutions</h4>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="accordionWrap">
              <FaqsAccordion items={accordionItems} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
